import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

// get measurement units
export const GetMeasurementUnitSchema = z.object({
  code: z.string().min(1),
});
export type GetMeasurementUnitCommand = z.infer<typeof GetMeasurementUnitSchema>;

// get measurement unit result
export const MeasurementUnitResultSchema = z.object({
  codeQualifyer: z.string().optional(),
  description: z.string().optional(),
  abbreviation: z.string().optional(),
  code: z.string().optional(),
  qualifyer: z.string().optional(),
});
export type MeasurementUnitResult = z.infer<typeof MeasurementUnitResultSchema>;

// update measurement unit
export const UpdateMeasurementUnitSchema = z.object({});
export type UpdateMeasurementUnitCommand = z.infer<typeof UpdateMeasurementUnitSchema>;

export const measurementUnitContract = c.router({
  getMeasurementUnit: {
    method: 'GET',
    path: '/external-api/measurement-unit-values',
    query: GetMeasurementUnitSchema,
    responses: {
      200: MeasurementUnitResultSchema,
      404: z.object({ message: z.string() }),
    },
  },
});
